// import './chat-preview.scss';

export { default } from './ChatPreview';
export { default as template } from './chat-preview.tpl';
